/**
 * A short unique id for local React keys. We don't use crypto.randomUUID() because it
 * only exists in a "secure context" (HTTPS or bare localhost) — on a plain-HTTP gym
 * subdomain in dev (e.g. iron-peak.127.0.0.1.sslip.io) it's undefined and throws. This
 * works everywhere; it's only ever used for client-side keys, never persisted as an id.
 */
export function uid(): string {
  const rand = Math.floor(Math.random() * 1e9).toString(36);
  return `k${performance.now().toString(36).replace('.', '')}${rand}`;
}
